export default __webpack_public_path__ + "static/media/loginPic.2941fe48.png";